document.addEventListener('DOMContentLoaded', function() {
  // Find all card wrappers with data-mobile-url attribute
  const cardWrappers = document.querySelectorAll('[data-mobile-url]');

  cardWrappers.forEach(wrapper => {
    const mobileUrl = wrapper.getAttribute('data-mobile-url');
    if (mobileUrl && mobileUrl.trim() !== '') {
      // Find all links in this wrapper
      const links = wrapper.querySelectorAll('a');

      links.forEach(link => {
        link.addEventListener('click', function(e) {
          // Check if on mobile (max-width: 749px)
          if (window.innerWidth <= 749) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = mobileUrl;
            return false;
          }
        });
      });
    }
  });
});
